import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.i6n_1 = code;
        this.j6n_1 = partyId;
        this.k6n_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.i6n_1 + ', partyId=' + this.j6n_1.toString() + ', guildId=' + this.k6n_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.i6n_1);
        result = imul(result, 31) + this.j6n_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.k6n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.i6n_1 === other.i6n_1))
          return false;
        if (!this.j6n_1.equals(other.j6n_1))
          return false;
        if (!(this.k6n_1 === other.k6n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
